import React, { Fragment, useState, useEffect } from "react";
import Header from "../common/header";
import Footer from "../common/footer";
import PricacyBanner from "./privacy-policy-banner";
import PrivacyDescriptions from "./privacy-policy-descriptions";

import * as apiUrl from "../../apiUrl";

function PrivacyPage() {
  const [pageData, setPageData] = useState([]);

  useEffect(() => {
    const fetchPage = async () => {
      try {
        const response = await fetch(
          apiUrl.apiUrl + `/api/privacy-policy/page`
        );
        if (!response.ok) {
          throw new Error("Page not found");
        }
        const data = await response.json();
        setPageData(data);
      } catch (error) {
        console.error("Error fetching page:", error);
      }
    };

    fetchPage();
  }, []);

  return (
    <Fragment>
      <Header />
      <PricacyBanner
        bannerImage={pageData.banner_image}
        bannerTitle={pageData.banner_title}
      />
      <PrivacyDescriptions description={pageData.description} />
      <Footer />
    </Fragment>
  );
}

export default PrivacyPage;
